import loadable from '@loadable/component';

import './EventInformation.css';

export default loadable(() => {
  return import('./EventInformation');
});
